<!--
 * @Description: 访问统计页面
 * @Author: laoliu
 * @Date: 2022-09-23 16:43:52
-->
<template>
  <access-report />
</template>

<script>
export default {
    mounted() {
        this.$emit("breadcrumb", {text1: '系统管理', text2: '访问统计'});
    }
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/sysmng/AccessStat.vue